import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { connect } from 'react-redux';
import { setContactRoleContact } from 'bundles/apex/deals/form/store/deal/actions';

import ContactSelector from 'bundles/backoffice/contacts/selector';
import { horizontalFormStyles } from 'helpers/react_select_helpers';

import './styles.scss';

export function DealContactRole({ contactRole, label, primary, required, setContactRoleContact }) {
  return (
    <div className={classNames('form-group deal-form-contact-role-inline', { required: required && primary })}>
      <label className="control-label">
        {label}
      </label>

      <div className="form-input-container">
        <ContactSelector
          contact={contactRole.contact}
          styles={horizontalFormStyles}
          onChange={contact => setContactRoleContact(contactRole, contact)}
        />
      </div>
    </div>
  );
}

DealContactRole.propTypes = {
  contactRole: PropTypes.object,
  label: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  required: PropTypes.bool,
  setContactRoleContact: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setContactRoleContact,
};

export default connect(null, mapDispatchToProps)(DealContactRole);
